'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var InputButton_module = require('./InputButton.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const InputButton = ({
  disabled,
  onClick
}) => /*#__PURE__*/React__default["default"].createElement("button", {
  className: clsx__default["default"]({
    [InputButton_module["default"].button]: true,
    [InputButton_module["default"].disabled]: disabled
  }),
  disabled: disabled,
  onClick: () => {
    if (onClick && !disabled) onClick();
  },
  onTouchEnd: e => {
    // this stops the mobile keyboard (at least on ios) from
    // automatically hiding itself after a message is sent.
    e.preventDefault();
    if (onClick && !disabled) onClick();
  },
  type: "button"
}, /*#__PURE__*/React__default["default"].createElement("svg", {
  role: "img",
  className: InputButton_module["default"].svg,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}, /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M10 15.8333V4.16663",
  stroke: "white",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M4.16675 9.99996L10.0001 4.16663L15.8334 9.99996",
  stroke: "white",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

exports["default"] = InputButton;
